import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if banner was previously dismissed
    const wasDismissed = localStorage.getItem('mobile-banner-dismissed') === 'true';
    
    if (wasDismissed) {
      setIsDismissed(true);
      return;
    }

    // Check if user is on mobile
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = (e) => {
    // Prevent event bubbling if clicking the X button
    if (e) {
      e.stopPropagation();
    }
    setIsVisible(false);
    setIsDismissed(true);
    // Save dismissal to localStorage so it persists across refreshes
    localStorage.setItem('mobile-banner-dismissed', 'true');
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="mobile-banner" onClick={handleDismiss}>
      <div className="mobile-banner-content">
        <div className="mobile-banner-icon">📱</div>
        <div className="mobile-banner-text">
          <div className="mobile-banner-title">Welcome to EternaVaults Mobile</div>
          <div className="mobile-banner-message">
            You can now sign up and use EternaVaults on your mobile device! 
            For the full experience, try our desktop version too.
          </div>
        </div>
        <button 
          className="mobile-banner-dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss banner"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default MobileBanner;
